"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSignature = exports.serializeSignature = void 0;
const serializeSignature = (item) => {
    const isValid = (0, exports.validateSignature)({
        type: "Signature",
        data: item.data,
        required: true,
    }).valid;
    return isValid ? "Signed" : "Not signed";
};
exports.serializeSignature = serializeSignature;
const validateSignature = (item) => {
    const pathCount = item.data.svgPaths?.length ?? 0;
    if (!item.required && pathCount === 0) {
        // not required and user did not fill out signature
        return {
            valid: true,
        };
    }
    else if (pathCount > 0) {
        const paths = parsePaths(item.data.svgPaths);
        const totalLength = getLengthOfAllPaths(paths);
        const valid = totalLength > 200;
        return {
            valid,
            error: valid
                ? undefined
                : {
                    message: "Provided signature does not meet requirements. Please try again.",
                },
        };
    }
    return {
        valid: false,
        error: { message: "Please provide a valid signature." },
    };
};
exports.validateSignature = validateSignature;
function getLengthOfAllPaths(paths) {
    return paths
        .map(getLengthOfPath)
        .reduce((totalLength, length) => totalLength + length, 0);
}
function getLengthOfPath(path) {
    return path.reduce((totalLength, point, index) => {
        if (index > 0) {
            const lastPoint = path[index - 1];
            // d = sqrt( (x2 - x1)^2 + (y2 - y1)^2 )
            const distance = Math.sqrt(Math.pow(point[0] - lastPoint[0], 2) +
                Math.pow(point[1] - lastPoint[1], 2));
            return totalLength + distance;
        }
        return totalLength;
    }, 0);
}
function parsePaths(svgPaths) {
    const stringPaths = [];
    svgPaths.forEach((svgPathString) => {
        // collect all the paths, including subpaths within a path.
        svgPathString.split("M").forEach((path) => {
            if (path.length > 0) {
                stringPaths.push("M" + path);
            }
        });
    });
    return stringPaths.map((svgPathString) => svgPathString
        .split(" ")
        .filter((p) => p !== "M" && p !== "L")
        .map((point) => point.split(",").map((p) => parseInt(p)))
        .filter((p) => p.length === 2 && !isNaN(p[0]) && !isNaN(p[1])));
}
//# sourceMappingURL=signature.js.map